import "./sc-intelligent-mail-barcode.scss";

import {to_isAddressable}  from "@Common/logic/template-options/template-options-is-addressable";
import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {scopedState}       from "@Common/react/scoped-state";
import {scnv}              from "@Common/react/state-change-nested-value";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {cnv}               from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {equalDeep, omit}   from "@Common/utils/objects";

import {ImbBase} from "@Xpresso/routes/common/heavy/imb/imb-base";

export const ScIntelligentMailBarcode = ({templateOptions, initEnrollment, agentId, next: rootNext}) => cs(
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("apis"),
    ["allowed", ({company, session}, next) => next(
        templateOptions &&
        to_isAddressable(templateOptions) &&
        true
    )],
    ["selected", (_, next) => UseState({ // If user wants to use bulk mail
        getInitValue: () => chain(
            initEnrollment?.distribution_options?.shipping?.addressed_copies,
            (_) => _?.mailer_id && {
                mailer_id      : true,
                mailer_id_class: ""+(_.mailer_id_class ?? "1"),
            },
            (_) => ({
                current: _,
                saved  : _,
            }),
        ),
        next,
    })],


    ["base", ({allowed}, next) => ImbBase({
        agentId,
        enabled: allowed,
        next,
    })],

    // ["calValue", ({selected, base}, next) => next(selected.value.current && {
    //     mailer_id      : true,
    //     mailer_id_class: +base.persistData.idMailClass,
    // })],

    ({selected, base}) => rootNext({
        ui: {
            selected: {
                value: !!selected.value.current,
                onChange: () => scnv(selected, ["current"], (_) => _ ? null : {
                    mailer_id: true,
                    mailer_id_class: "1",
                }),
            },
            render: ({showErrors}) => (
                base.render({
                    showErrors,
                    idMailClass: scopedState(selected, ["current", "mailer_id_class"]),
                })
            ),
        },

        enrollmentEditor: {

            prepareSave: (enrollmentEditor) => ({
                newValue: cnv(
                    enrollmentEditor, ["distribution_options", "shipping", "addressed_copies"],
                    (_) => ({
                        ...omit(_, ["mailer_id", "mailer_id_class"]),
                        ...selected.value.current,
                    })
                ),
                onSaved: () => setCurrentToSaved(selected),
            }),

            changed: !equalDeep(selected.value.current, selected.value.saved),
            // changed: selected.value.saved !== selected.value.current,

            valid: !selected.value.current || base.valid,
            errorsHandling: {
                highlightErrors: base.highlightErrors,
            },
        },
    }),
);
